//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.SheetMetal.SheetmetalBaseBuilder.js";
import "../no/Expression.js";
import "../Features/Features.SheetMetal.ConvertInputListItemBuilderList.js";
import "../no/ScCollector.js";
import "../no/Features.js";
import "../no/ObjectList.js";
let d=[[[0,"AdditionalFacesToConvert",0,"ScCollector",0],[0,"BaseFace",1,"Face",0],[1,"BendReliefDepth",0,"Expression",0],[0,"BendReliefType",1,0],[1,"BendReliefWidth",0,"Expression",0],[1,"CornerList",0,"Features.SheetMetal.ConvertInputListItemBuilderList",0],[0,"IsUniformThickness",1,0],[0,"LocalBaseFace",1,"Face",0],[0,"LocalRegionFaces",0,"ScCollector",0],[0,"MaintainZeroBendRadius",1,0],[0,"RipSection",1,"Section",0],[0,"Sketch",1,"Features.SketchFeature",0]],[[["number_of_rip_edges"],"GetRipEdges",{R_:{rip_edges:"Edge[]"}},0,0],[["rip_edges"],"SetRipEdges",{},1,0],[[],"ValidateBuilderData",{R_:{builder_data_validity:''}},0,0],[[],"CreateConvertInputListItem",{R_:{listitem:"Features.SheetMetal.ConvertInputListItemBuilder"}},0,0]],[]];
SPLM.Features.SheetMetal.ConvertToSheetmetalBuilder = class extends SPLM.Features.SheetMetal.SheetmetalBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.ConvertToSheetmetalBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.ConvertToSheetmetalBuilder.BendReliefTypeOptions = Object.freeze({
    "None" : "None", "Square" : "Square", "Round" : "Round"});

export default SPLM;